import platformDetection from '../components/utils/PlatformDetection';

const properties = {
    init() {
        if (platformDetection.isIOS() == true) {
            this.BROWSER_WIDTH = 226;
        }
    },

    // canvas properties
    CANVAS_VERTICAL_TOP_PADDING: 5,
    CANVAS_VERTICAL_BOTTOM_PADDING: 5,
    CANVAS_HORIZONTAL_PADDING: 0,

    // menus properties
    INSERT_MENU_WIDTH: 130,
    INSERT_MENU_HEIGHT: 180,
    INSERT_MENU_BUTTON_SIZE: 42,
    INSERT_MENU_BUTTON_HOVER_COLOR: 'black',
    INSERT_MENU_BUTTON_COLOR: '#2479BE',
    SLIDE_MENU_WIDTH: 105,
    SLIDE_MENU_HEIGHT: 200,
    SLIDE_MENU_BUTTON_HEIGHT: 40,
    SLIDE_MENU_COLOR: '#FFFFFF',
    SLIDE_MENU_HOVER_COLOR: '#EBEBEB',
    SHAPE_MENU_WIDTH: 116,
    SHAPE_MENU_BUTTON_HEIGHT: 40,
    MAIN_MENU_WIDTH: 38,
    MAIN_RESIZE_BUTTON_WIDTH: 15,

    // browser accordion properties
    CLIPART_BUTTON_HEIGHT_OLD:40,
    CLIPART_BUTTON_HEIGHT:30,
    BROWSER_BUTTON_HEIGHT: 30,
    UNIVERSE_BUTTON_HEIGHT: 38,
    ANIMATION_STEP: 50,
    BROWSER_WIDTH: 328,
    BROWSER_ICON_RIGHT_PADDING: 18,
    BROWSER_LEFT_PADDING: 20,
    BROWSER_SELECTED_COLOR: '#434343',
    CLIPART_BUTTON_COLOR: '#318dcf',
    BROWSER_COLOR: '#F7F7F7',
    BROWSER_HOVER_COLOR: '#EBEBEB',

    // buttons holder style
    BUTTONS_HOLDER_WIDTH: 220,
    BUTTONS_HOLDER_COLLAPSED_WIDTH: 70,
    BUTTONS_HOLDER_LEFT_GAP: 7,
    BUTTONS_HOLDER_TOP_GAP: 8,
    SLIDE_VIEWER_BUTTONS_GAP: 8,

    // slideViewer properties
    SLIDE_VIEWER_HORIZONTAL_GAP: 10,
    SLIDE_VIEWER_BACKGROUND: '#D7D7D7',
    SLIDE_VIEWER_LIST_BACKGROUND: '#D7D7D7',
    SLIDE_VIEWER_TOP_GAP: 5,
    SLIDE_VIEWER_BUTTON_SELECTED_COLOR: '#2196F3',
    SLIDE_VIEWER_MIDDLE_GAP: 5,
    SLIDE_VIEWER_BOTTOM_GAP: 5,
    SLIDE_VIEWER_BUTTON_WIDTH: 40,
    SLIDE_VIEWER_TOP_LINE_HEIGHT: 0,
    SLIDE_VIEWER_LIST_HEIGHT: 81,
    SLIDE_ITEM_WIDTH: 105,
    SLIDE_GAP: 5,
    SLIDE_SELECTION_WIDTH: 2,
    SLIDE_SELECTION_COLOR: '#ff00ff',
    SLIDE_PADDING_DROP: 50,
    SLIDE_MENU_BUTTON_TOP_PADDING: 11,
    SLIDE_MENU_BUTTON_RIGHT_PADDING: 5,
    SLIDE_FRAME_SELECTED_COLOR: '#2D2D2D',
    SLIDE_FRAME_HOVER_COLOR:'#0090E8',
    SLIDE_MENU_BUTTON_SIZE: 30,
    SHAPE_MENU_BUTTON_SIZE: 30,
    GROUP_BUTTON_WIDTH: 220,
    GROUP_BUTTON_HEIGHT: 40,
    ADD_MUSIC_BACKGROUND: '#F6F6F6',
    ADD_MUSIC_HEIGHT: 38,
    ADD_MUSIC_BUTTON_HEIGHT: 28,
    ADD_MUSIC_BUTTON_WIDTH: 110,
    STORY_SOUND_BUTTON_WIDTH: 300,
    ADD_MUSIC_BUTTON_BACKGROUND: '#FFFFFF',

    // preview menu
    PREVIEW_HEIGHT: 45,
    PREVIEW_COLOR: '#D7D7D7',
    PREVIEW_BUTTON_SIZE: 20,
    PREVIEW_BUTTON_COLOR: '#FFFFFF',
    PREVIEW_BUTTONS_GAP: 10,

    // recording menu
    RECORDING_MENU_HEIGHT: 38,
    RECORDING_MENU_BACKGROUND: '#D7D7D7',
    RECORDING_BUTTON_HEIGHT: 28,
    RECORDING_PLAY_BUTTON_WIDTH: 53,
    RECORDING_DURATION_BUTTON_WIDTH: 70,
    RECORDING_DURATION_BUTTON_EXPANDED: 190,
    RECORGING_SLIDER_WIDTH: 125,
    RECORDING_GAP: 15,
    RECORDING_RECORD_WIDTH: 98,
    RECORDING_SOUND_BUTTON_WIDTH: 70,

    //Object Advanced menu
    OBJECT_ADVANCED_BUTTON_HEIGHT: 50,
    OBJECT_ADVANCED_MIDDLE_GAP: 20,
    CONTEXT_HOVER_COLOR:'#0090E8',
    EFFECTS_PADDING: 20,
    EFFECTS_BUTTON_HEIGHT: 40,
    EFFECTS_BUTTON_BORDER_COLOR: '#E1E1E1',
    EFFECTS_LIST_PADDING: 5,
    EFFECTS_CORNER_GAP: 15,

    //Styling menu
    STYLING_TOP_GAP: 20,
    STYLING_LEFT_GAP: 20,
    STYLING_BUTTON_HEIGHT: 45,
    STYLING_SLIDER_HEIGHT: 35,
    STYLING_THUMB_SIZE: 25,

    //ColorPicker
    RAINBOW_SELECTOR_SIZE: 24,
    RAINBOW_SELECTOR_STROKE_WIDTH: 2,
    RAINBOW_WIDTH: 10,
    RAINBOW_HEIGHT: 210,
    COLOR_GRADIENT_SELECTOR_SIZE: 20,
    COLOR_GRADIENT_SELECTOR_STROKE_WIDTH: 2,

    //Text Styling menu
    TEXT_STYLING_BUTTON_WIDTH: 50,
    TEXT_STYLING_BUTTON_HEIGHT: 35,

    //Toggle button
    TOGGLE_TRACK_WIDTH: 60,
    TOGGLE_TRACK_HEIGHT: 19,
    TOGGLE_THUMB_SIZE: 25,

    // keyboard commands
    MOVE_SHAPE_OFFSET: 5,
    MOVE_SHAPE_BIG_OFFSET: 15,

    DURATION_SLIDER_COLOR: '#767676',

    MENUS_BORDER_COLOR: '#E1E1E1',
    SOUND_EVEN_COLOR: '#F0F0F0',
    SOUND_ODD_COLOR: '#FFFFFF',
    SOUND_ITEM_HEIGHT: 40,
    SOUND_ITEMS_GAP: 8,

    MOOD_ITEM_SIZE: 170,
    MOOD_ITEM_GAP: 10,

    MY_MEDIA_FILES_GAP: 10,

    SHAPE_SIZE: 100,
    MIND_MAP_NODE_SIZE: 100,
    IMAGE_SIZE: 250,
    TEXT_WIDTH: 150,
    TEXT_HEIGHT: 100,
    RICH_TEXT_WIDTH: 220,
    RICH_TEXT_HEIGHT: 45,

    TEXT_PADDING: 0,
    TEXT_INNER_PADDING: 7,
    MIN_FONT_SIZE: 5,
    MAX_FONT_SIZE: 500,

    //Delete Alert
    DELETE_ALERT_BACKGROUND: '#333333',
    DELETE_ALERT_BACKGROUND_OPACITY: 0.7,
    DELETE_ALERT_WIDTH: 550,
    DELETE_ALERT_TOP_BAR_HEIGHT: 40,
    DELETE_ALERT_BOTTOM_BAR_HEIGHT: 300,
    DELETE_ALERT_BUTTON_WIDTH: 100,
    DELETE_ALERT_BUTTON_HEIGHT: 30,
    DELETE_ALERT_BUTTON_GAP: 20,

    //Record ToolTip
    RECORD_TOOLTIP_WIDTH: 198,
    RECORD_TOOLTIP_STEM_SIZE: 12,
    RECORD_TOOLTIP_BACKGROUND: '#434343',

    //Navigation Bar
    DESCRIBE_BOX_WIDTH: 300,

    //AudioEditor
    AUDIO_TIMELINE_HEIGHT: 50,
    AUDIO_BORDER: '#5B5B5B',
    LINE_SIZE: 2,
    LINE_HOLDER_HEIGHT: 14,
    LINE_HOLDER_HEIGHT_IOS: 25,
    SLIDE_EXTENDED_BACKGROUND_COLOR: '#00B2EE',
    ARROW_SIZE: 20,
    SOUND_GAP: 7,
    TITLE_WIDTH: 100,
    RULER_HEIGHT: 30,
    DELETE_BUTTON_SIZE: 26,
    SPLIT_BUTTON_SIZE: 32,
    AUDIO_MINIMUM_LENGTH: 0.5, // Seconds
    AUDIO_EDITOR_BUTTON_GAP: 10,
    AUDIO_CONTROL_POINT_SIZE: 14,
    AUDIO_CONTROL_POINT_SIZE_IOS: 25,
    VOLUME_CONTROL_LINE_SIZE: 2,

    CATEGORY_SELECTOR_GAP: 10,
    CATEGORY_SELECTOR_HEIGHT: 60,

    //AudioTool
    AUDIO_TIMELINE_BIG_HEIGHT: 70,
    HEADER_HEIGHT: 120,
    HEADER_HEIGHT_APP: 120,
    PLAYER_BAR_HEIGHT: 120,
    PLAYER_BAR_HEIGHT_FOR_CARTOONIST: 65,
    PLAYHEAD_SIZE: 40,
    PLAYHEAD_SIZE_FOR_CARTOONIST: 20,
    AUDIO_BROWSER_SCROLL_WIDTH: 20,

    AUTO_SCROLL_STEP: 30,

    SEARCH_HEIGHT() {
        if (platformDetection.isIOS())
            return this.CLIPART_BUTTON_HEIGHT_OLD;
        else
            return this.CLIPART_BUTTON_HEIGHT;
    }
};

export default properties;



/** WEBPACK FOOTER **
 ** ./src/constants/Properties.js
 **/